/**
 * gatsby-theme-objects browser APIs.
 *
 * wrapPageElement mounts the ChatWidget host on EVERY page of the consuming
 * site (landingpage build = the whole objects.press prod), including pages
 * that do not use Layout (/pricing/, configurator shells). The host renders
 * null until client mount, so there is no SSR/hydration mismatch, and it
 * self-excludes on internal surfaces + iframes (see ChatWidgetHost.js).
 *
 * The former per-Layout mount was removed in the same change — one mount only.
 */

import React from 'react';
import ChatWidgetHost from './src/components/ChatWidget/ChatWidgetHost';

export const wrapPageElement = ({ element, props }) => (
  <>
    {element}
    <ChatWidgetHost location={props.location} />
  </>
);
